import LocalisationService from './localisation-service';
import TranslationService from './translation-service';

import type { I18nServiceType } from '@shared/types/i18n';

const I18nService: I18nServiceType = (
  { cldr, culture, translations },
  logger,
) => {
  const translationService = TranslationService({ translations, logger });
  const localisationService = LocalisationService(cldr, culture, logger);
  return {
    ...translationService,
    ...localisationService,
    culture,
    translations: () => translations,
    cldr: () => cldr,
  };
};

export default I18nService;
